export const roleColorMap = {
    sponsor: {
        ring: 'tw-ring-sky-400 tw-border-sky-400',
        stroke: 'tw-stroke-sky-600',
        text: 'tw-fill-white'
    },
    exhibitor: {
        ring: 'tw-ring-purple-500 tw-border-purple-500',
        stroke: 'tw-stroke-purple-600',
        text: 'tw-fill-white'
    },
    speaker: {
        ring: 'tw-ring-amber-200 tw-border-amber-200',
        stroke: 'tw-stroke-amber-200',
        text: 'tw-fill-gray-700'
    },
    attendee: {
        ring: 'tw-ring-gray-500 tw-border-gray-500',
        stroke: 'tw-stroke-gray-600',
        text: 'tw-fill-white'
    },
    buyer: {
        ring: 'tw-ring-emerald-400 tw-border-emerald-400',
        stroke: 'tw-stroke-emerald-600',
        text: 'tw-fill-white'
    },
    admin: {
        ring: 'tw-ring-red-500 tw-border-red-500',
        stroke: 'tw-stroke-red-600',
        text: 'tw-fill-white'
    },
    default: {
        ring: 'tw-ring-blue-500 tw-border-blue-500',
        stroke: 'tw-stroke-blue-600',
        text: 'tw-fill-white'
    }
};

// Connection request default message
export const defaultConnectionMessage = "Hi! I would like to connect with you.";